window.PS = (function(){
    var events = {};
    function on(eventName, fn) {
        events[eventName] = events[eventName] || [];
        events[eventName].push(fn);
    }

    function off(eventName, fn) {
        if (events[eventName]) {
            events[eventName].filter(f => f !== fn);
        }
    }

    function fire(eventName, data) {
        if (events[eventName]) {
            events[eventName].forEach( fn => { fn(data); });
        }
    } 

    return { 
        on: on,
        off: off,
        fire: fire,
    }
})()